import { gql } from '@apollo/client';

export const GetMyContactQueryName = 'GetMyContact';

export const GET_MY_CONTACT_QUERY = gql`
  query ${GetMyContactQueryName}($id: String!) {
    getMyContact(id: $id) {
      id
      createdAt
      responderUser
      email
      displayName
      sharedWithMe {
        id
        kind
        level
        name
      }
      sharedByMe {
        id
        kind
        level
        name
      }
    }
  }
`;
